module.exports = __webpack_public_path__ + "img/1f496.257ec62.svg";